"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useContractDeployMonitor = void 0;

var _react = require("react");

var _types = require("../types");

var _status = require("../status");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/* --- Effect --- */
var useContractDeployMonitor = (state, dispatch) => {
  (0, _react.useEffect)(() => {
    if (filterTransaction(state.activity.deploy)) {
      var runEffect =
      /*#__PURE__*/
      function () {
        var _ref = _asyncToGenerator(function* () {
          var transactionRequest = Object.keys(state.activity.deploy).filter(tx => state.activity.deploy[tx].status === _status.CONTRACT_DEPLOY_SUBMITTED)[0];
          var transactionConfirmation = yield state.wallet.provider.waitForTransaction(state.activity.deploy[transactionRequest].payload.hash);
          console.log(transactionConfirmation, "contracttransactionConfirmation");

          try {
            dispatch({
              type: _types.CONTRACT_DEPLOY_MONITOR_SUCCESS,
              payload: transactionConfirmation
            });
          } catch (error) {
            dispatch({
              type: _types.CONTRACT_DEPLOY_MONITOR_FAILURE,
              payload: error
            });
          }
        });

        return function runEffect() {
          return _ref.apply(this, arguments);
        };
      }();

      runEffect();
    }
  }, [state.activity.deploy]);
};

exports.useContractDeployMonitor = useContractDeployMonitor;

var filterTransaction = txList => Object.keys(txList).filter(tx => txList[tx].status === _status.CONTRACT_DEPLOY_SUBMITTED).length > 0 ? true : false;